module.exports = __webpack_public_path__ + "img/Icone_96.81422c71.png";